import { render, staticRenderFns } from "./DIASEvents.vue?vue&type=template&id=8c214314&"
import script from "./DIASEvents.vue?vue&type=script&lang=js&"
export * from "./DIASEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports